const scormSessionEndedTemplate = ({screenReaderAlertText, scormSessionEndedText}) => `<div class="scorm-session-complete-container">
   <span class="sr-only" role="status" aria-live="polite">${screenReaderAlertText}</span>
   <span>${scormSessionEndedText}</span>
</div>`;

export default scormSessionEndedTemplate;
